import React from 'react'
import FormInput from '../../../../../library/form/components/FormInput';
import FormLabel from '../../../../../library/form/components/FormLabel';
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormWrapper from '../../../../../library/form/components/FormWrapper';

const ProdIOOExoCMNEditor = (props) => {
    const { formObject } = props;

    return (
        <>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "actualItem" }} value="Selected Item" />
                </span>
                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "actualItem" }}/>
            </li>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qtyRequired1" }} value="Req Qty 1" />
                </span>
                <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" 
                    action={{ InputType: "input", actionId: "refresh", paramName: "qtyRequired1", actionParam:{"formulaSource":"req", "updateQty":1} }}
                    className=''/>
                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "unit1" }} className="uiSpacerH10"/>
                <span className="uiLblInLine">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qtyRequired2" }} value="Req Qty 2" />
                </span>
                <FormInput style={{width:"70px"}} formObject={formObject} rowKey=""
                    action={{ InputType: "input", actionId: "refresh", paramName: "qtyRequired2", actionParam:{"formulaSource":"req", "updateQty":1} }} className=''/>
                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "unit2" }} className="uiSpacerH10"/>
            </li>
            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass=""
                    action={{ paramName: "resUnitCost" }} >
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "resUnitCost" }} value="Item Unit Cost" />
                </span>
                <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" action={{ InputType: "input", actionId: "refresh", paramName: "resUnitCost", actionParam:{formulaSource: "RC", updateQty : "1", actionType:"updateCost" }}}/>
            </FormWrapper>
            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass=""
                    action={{ paramName: "processUnitCost" }} >
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "processUnitCost" }} value="Labor Unit Cost" />
                </span>
                <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" action={{ InputType: "input", actionId: "refresh", paramName: "processUnitCost", actionParam:{formulaSource: "RC", updateQty : "1", actionType:"updateCost" }}}/>
            </FormWrapper>
            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass=""
                    action={{ paramName: "ohUnitCost" }} >
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ohUnitCost" }} value="OH Unit Cost" />
                </span>
                <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" action={{ InputType: "input", actionId: "refresh", paramName: "ohUnitCost", actionParam:{formulaSource: "RC", updateQty : "1", actionType:"updateCost" }}}/>
            </FormWrapper>
            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass=""
                    action={{ paramName: "totalUnitCost" }} >
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalUnitCost" }} value="Total Unit Cost" />
                </span>
                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "totalUnitCost" }} className="uiSpacerH10"/>
            </FormWrapper>
        </>
    )
}

export default ProdIOOExoCMNEditor;
